/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ClockCircleOutlined,
  FileOutlined,
  LoadingOutlined,
  PicLeftOutlined,
} from '@ant-design/icons'
import { Avatar, Card, Col, Flex, Row, Tag, Typography } from 'antd'
import React from 'react'
import { useTask } from '~/hooks/Tasks/useTask'
import { translate } from '~/utils/locale'
import ExeuctionTimeCountdown from './ExecutionTimeCountdown'
import ToleranceTimeCountdown from './ToleranceTimeCountdown/ToleranceTimeCountdown'

// import { Container } from './styles';

const TaskTypeTaskDetails: React.FC = () => {
  const { task, isLoading } = useTask()

  const { Title, Text } = Typography

  if (isLoading || !task?.taskType) {
    return <LoadingOutlined style={{ fontSize: 64, margin: 'auto' }} spin />
  }

  const checkInStatus: any = task.status.find((t) => t.type === 'check-in')

  return (
    <>
      <Card
        bordered={false}
        title={
          <Title level={5} style={{ marginBottom: 0, fontSize: 18 }}>
            {translate('TasksTabsDetails.taskTypeCardTitle')}
          </Title>
        }
        style={{
          display: 'inline-block',
          width: '100%',
          marginTop: 15,
        }}
      >
        <Row>
          <Col span={12}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <FileOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('TasksTabsDetails.taskTypeTitle')}
                </Title>
                <Text>{task.taskType.title}</Text>
              </div>
            </Flex>
          </Col>
          <Col span={12}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <PicLeftOutlined style={{ fontSize: 12, color: '#464545' }} />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('TasksTabsDetails.description')}
                </Title>
                {task.taskType.description ? (
                  <Text>{task.taskType.description}</Text>
                ) : (
                  <Text>Nenhuma descrição foi fornecida.</Text>
                )}
              </div>
            </Flex>
          </Col>
        </Row>

        <Row style={{ marginTop: 14 }}>
          <Col span={12}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <ClockCircleOutlined
                    style={{ fontSize: 12, color: '#464545' }}
                  />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('TasksTabsDetails.runtime')}
                </Title>
                {task.current_status === 'finished' ? (
                  <Text>{translate('TasksTabsDetails.statusFinished')}</Text>
                ) : (
                  <ExeuctionTimeCountdown
                    executionTime={task.taskType.runtime}
                    status={task.current_status}
                    checkinDate={
                      checkInStatus ? checkInStatus.created_at : new Date()
                    }
                  />
                )}
              </div>
            </Flex>
          </Col>
          <Col span={12}>
            <Flex gap={10}>
              <Avatar
                shape="square"
                icon={
                  <ClockCircleOutlined
                    style={{ fontSize: 12, color: '#464545' }}
                  />
                }
                size="small"
                style={{ background: '#DADADA' }}
              />
              <div>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {translate('TasksTabsDetails.toleranceTime')}
                </Title>
                <Text>
                  {task.taskType.tolerance_time}
                  {task.current_status === 'working' ? (
                    <Tag>{translate('TasksTabsDetails.workingStatusText')}</Tag>
                  ) : (
                    <ToleranceTimeCountdown
                      toleranceTime={task.taskType.tolerance_time}
                      status={task.current_status}
                      created_at={task.createdAt}
                    />
                  )}
                </Text>
              </div>
            </Flex>
          </Col>
        </Row>
      </Card>
    </>
  )
}

export default TaskTypeTaskDetails
